import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSettings, waLink, fullAddress, EASE } from "../lib/site";
import { SocialLinks } from "./Location";

export const Footer = () => {
  const s = useSettings();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--ink)] pt-20 text-[var(--cream)]">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 md:grid-cols-3 md:px-10">
        <div>
          <img src="/img/logo-aura-light.png" alt="AURA Microblading & Nails" data-testid="footer-logo" className="h-auto w-56" />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-[var(--nude)]">Atelier di microblading e ricostruzione unghie.</p>
        </div>
        <div className="text-sm leading-loose text-[var(--cream)]/85">
          <p className="mb-3 text-xs uppercase tracking-[0.28em] text-[var(--nude)]">Studio</p>
          <p>{fullAddress(s)}</p>
          <a data-testid="footer-phone" href={waLink(s)} target="_blank" rel="noreferrer" className="hover:text-[var(--gold)]">{s.phone}</a>
        </div>
        <div>
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-[var(--nude)]">Social</p>
          <SocialLinks s={s} />
        </div>
      </div>
      <motion.p initial={{ y: "40%", opacity: 0 }} whileInView={{ y: "0%", opacity: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.4, ease: EASE }} aria-hidden className="gold-text mt-16 select-none text-center font-display text-[30vw] leading-[0.8] tracking-[0.04em]">
        AURA
      </motion.p>
      <div className="mx-auto flex max-w-[1400px] flex-col justify-between gap-3 border-t border-white/10 px-5 py-6 text-xs text-[var(--nude)] sm:flex-row md:px-10">
        <p>© 2026 AURA · Microblading & Nails · Frascati</p>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[var(--gold)]">Area riservata</Link>
      </div>
    </footer>
  );
};
